import { AnalyticsBrowser } from '@segment/analytics-next';

export const identify = async (sessionData: any) => {
  if (!import.meta.env.VITE_SEGMENT_WRITE_KEY) {
    console.log("skip sending identity to segment analytics due to missing SEGMENT_WRITE_KEY.");
    return Promise.resolve();
  }

  const analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY })

  if (!sessionData || Object.keys(sessionData).length === 0) {
    console.log("skip sending identity to segment analytics due to missing session data.");
    return Promise.resolve();
  }

  const userAttributes = sessionData?.user?.attributes || {};
  const teamAttributes = sessionData?.team?.attributes || {};

  const userCrn = userAttributes.crn ?? "";
  const email = userAttributes.email ?? "";
  const firstname = userAttributes.firstname ?? "";
  const lastname = userAttributes.lastname ?? "";
  const teamId = teamAttributes.id ?? "";
  const teamCrn = teamAttributes.crn ?? "";
  const groupId = teamAttributes.crn ?? "";
  const userId = userAttributes.id ?? "";

  // CRN parsing
  const crnParts = userCrn.split(":");
  const tenant = crnParts.length >= 4 ? crnParts[1] : "";      // cupix
  const regionCode = crnParts.length >= 4 ? crnParts[2] : "";  // uswe2
  const region = regionCode ? regionCode.substring(0, 2).toUpperCase() : "";  // US

  await analytics.identify(userCrn, {
    user_name: `${firstname} ${lastname}`,
    user_email: email
  },
  {
    context: {
      traits: {
        user_name: `${firstname} ${lastname}`,
        user_email: email,
        team_id: teamId,
        team_crn: teamCrn,
        tenant,
        region_code: regionCode,
        region,
        group_id: groupId,
        user_id: userId
      },
    },
    email,
    firstname,
    lastname,
    team_id: teamId,
    team_crn: teamCrn,
    tenant,
    region_code: regionCode,
    region,
    group_id: groupId,
    user_id: userId
  });
}
